export const STATES = [
  {
    label: "Jammu & Kashmir",
    key: "Jammu & Kashmir",
  },
  {
    label: "Himachal Pradesh",
    key: "Himachal Pradesh",
  },
  {
    label: "Punjab",
    key: "Punjab",
  },
  {
    label: "Uttarakhand",
    key: "Uttarakhand",
  },
  {
    label: "Haryana",
    key: "Haryana",
  },
  {
    label: "Maharashtra",
    key: "Maharashtra",
  },
  {
    label: "Rajasthan",
    key: "Rajasthan",
  },
  {
    label: "Tamil Nadu",
    key: "Tamil Nadu",
  },
  {
    label: "Kerala",
    key: "Kerala",
  },
  {
    label: "Andaman & Nicobar Island",
    key: "Andaman & Nicobar Island",
  },
  {
    label: "Arunanchal Pradesh",
    key: "Arunanchal Pradesh",
  },
  {
    label: "Assam",
    key: "Assam",
  },
  {
    label: "Bihar",
    key: "Bihar",
  },
  {
    label: "Chandigarh",
    key: "Chandigarh",
  },
  {
    label: "Chhattisgarh",
    key: "Chhattisgarh",
  },
  {
    label: "Delhi",
    key: "Delhi",
  },
  {
    label: "Goa",
    key: "Goa",
  },
  {
    label: "Jharkhand",
    key: "Jharkhand",
  },
  {
    label: "Madhya Pradesh",
    key: "Madhya Pradesh",
  },
  {
    label: "Manipur",
    key: "Manipur",
  },
  {
    label: "Meghalaya",
    key: "Meghalaya",
  },
  {
    label: "Mizoram",
    key: "Mizoram",
  },
  {
    label: "Nagaland",
    key: "Nagaland",
  },
  {
    label: "Odisha",
    key: "Odisha",
  },
  {
    label: "Sikkim",
    key: "Sikkim",
  },
  {
    label: "Telangana",
    key: "Telangana",
  },
  {
    label: "Tripura",
    key: "Tripura",
  },
  {
    label: "West Bengal",
    key: "West Bengal",
  },
  {
    label: "Gujarat",
    key: "Gujarat",
  },
  {
    label: "Uttar Pradesh",
    key: "Uttar Pradesh",
  },
  {
    label: "Andhra Pradesh",
    key: "Andhra Pradesh",
  },
  {
    label: "Karnataka",
    key: "Karnataka",
  },
];
export const INDUSTRY = [
  { label: "Agricultural", value: "AGRICULTURAL" },
  { label: "Industrial", value: "INDUSTRIAL" },
  { label: "Others", value: "OTHERS" },
];
